<template>
  <div>
    <el-form label-width="102px">
      <el-form-item label="账号：">{{ datas.account }}</el-form-item>
      <el-form-item label="名称：">{{ datas.name }}</el-form-item>
      <el-form-item label="所属单位：">{{ datas.teamName }}</el-form-item>
      <el-form-item label="业务模块：">{{ datas.bizModel }}</el-form-item>
      <el-form-item label="事件：">{{ datas.event }}</el-form-item>
      <el-form-item label="结果：">{{ datas.result }}</el-form-item>
      <el-form-item label="时间：">{{ datas.createAt }}</el-form-item>
      <el-form-item label="操作系统：">{{ datas.os }}</el-form-item>
      <el-form-item label="浏览器：">{{ datas.browser }}</el-form-item>
      <el-form-item class="special" label="详细信息：">{{ datas.detailText }}</el-form-item>
    </el-form>
    <div style="text-align: center">
      <el-button type="danger" size="mini" style="width: 150px" @click="close">关闭</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    params: Object
  },
  data() {
    return {
      datas: {}
    };
  },
  mounted() {
    this.leftForById();
  },
  methods: {
    close() {
      this.$emit('close');
    },
    leftForById() {
      let par = { id: this.params.id };
      httpKit.post($api_eap.log.info, par).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.result === 'true') {
            res.data.data.result = '成功';
          } else {
            res.data.data.result = '失败';
          }
          this.datas = res.data.data;
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.el-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.el-form-item {
  width: 30%;
  margin-bottom: 0px;
}
.special {
  width: 96%;
}
</style>
